import React, { useState } from "react";
import { Container, Form, Button, Card, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { authService } from '../services/authService';
import urlImage from "../assets/images/auth-image.png";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    
    try {
      const response = await authService.sendPasswordResetLink(email);
      
      if (response) {
        setMessage("Password reset instructions have been sent to your email.");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to process request. Please try again.");
    }
  };

  return (
    <Container fluid className="vh-100">
      <Row className="h-100 justify-content-center">
        <Col lg={4} md={12} sm={12} className="d-none d-md-block">
          <div 
            className="h-100 w-100" 
            style={{
              backgroundImage: `url(${urlImage})`,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center'
            }}
          />
        </Col>
        <Col lg={6} md={12} sm={12} className="d-flex justify-content-center align-items-center">
          <Card style={{ width: "350px" }} className="p-4 shadow br-radius-12">
            <div className="text-start mb-3">
              <Button 
                variant="link" 
                onClick={handleBack}
                className="text-dark p-0"
                style={{ textDecoration: 'none' }}
              >
                ←
              </Button>
            </div>
            <div className="text-center mb-4">
              <h5 className="GeneralSansSemibold pt-3 fs-20">Forgot Password</h5>
              <p className="mb-0 fs-14">Enter your email to reset password</p>
            </div>
            <Form onSubmit={handleSubmit}>
              {error && <div className="alert alert-danger mb-3">{error}</div>}
              {message && <div className="alert alert-success mb-3">{message}</div>}
              
              <Form.Group controlId="formBasicEmail" className="mb-3">
                <Form.Label className="fs-12">Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>

              <Button variant="success" type="submit" className="w-100">
                Reset Password
              </Button>
              <p className="fs-12 mt-3 text-center">
                Remember your password? <a className="text-dark" href="/auth/login">Login here</a>
              </p>
            </Form>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ForgotPassword; 